import { render } from "./loginPage.vue?vue&type=template&id=4bcd2432"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dmart\\Desktop\\Mi codigo\\maneiros_v2\\dotaappnofactu\\jano\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__